import { Play } from "lucide-react";
import { fileUrl, CATEGORIES } from "@/lib/api";

export const MediaTile = ({ item, onOpen, className = "" }) => (
  <button onClick={onOpen} data-testid={`gallery-item-${item.id}`}
    className={`img-zoom group relative block w-full overflow-hidden bg-[#1D3324] text-left ${className}`}>
    {item.type === "video" ? (
      <video src={`${fileUrl(item.url)}#t=0.5`} muted playsInline preload="metadata" className="h-full w-full object-cover" />
    ) : (
      <img src={fileUrl(item.url)} alt={item.title} loading="lazy" className="h-full w-full object-cover" />
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80 transition-opacity group-hover:opacity-100" />
    {item.type === "video" && (
      <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-[#8B2B22] transition-transform group-hover:scale-110">
        <Play size={26} fill="currentColor" />
      </span>
    )}
    <span className="absolute bottom-0 left-0 right-0 p-4 text-stone-100">
      <span className="block text-[10px] uppercase tracking-[0.25em] text-[#C5A059]">
        {CATEGORIES.find((c) => c.value === item.category)?.label}
      </span>
      <span className="f-display block text-lg leading-snug">{item.title}</span>
    </span>
  </button>
);
